module.exports = __webpack_public_path__ + "static/media/Baseball Fielder.078fbe07.jpg";